import * as Sentry from "@sentry/react";
import { ReactNode } from "react";

function ErrorFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-8">
      <div className="text-center space-y-4 max-w-md">
        <h1 className="text-2xl font-semibold text-foreground">
          Something went wrong
        </h1>
        <p className="text-muted-foreground">
          We've been notified. Try refreshing the page.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="px-4 py-2 rounded-md bg-primary text-primary-foreground hover:opacity-90 transition-opacity"
        >
          Reload
        </button>
      </div>
    </div>
  );
}

export function SentryErrorBoundary({ children }: { children: ReactNode }) {
  return (
    <Sentry.ErrorBoundary
      fallback={<ErrorFallback />}
      onError={(error) => {
        console.error("[SentryErrorBoundary] Error captured:", error);
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
